import * as angular from "angular";
import template from "./entity-geometries-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityGeometriesTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
}

// eslint-disable-next-line no-redeclare
export class EntityGeometriesTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewGeometries = globs.entityTypes.byType(this.typeConfig.Code).geometries.byCode("*").read;
		this.tab = {
			name: "Geometries",
			code: "GEOMETRIES",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewGeometries)
				&& isSupportedOrNullish(this.typeConfig.Geometries)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-geometries-tab", [])
	.component("entityGeometriesTab", {
		controller: EntityGeometriesTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<"
		}
	})
	.name;
